import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { toDeva } from '@shared/lib/format.ts';

/**
 * Full-page error screen in the site's style — big status number, plain
 * Marathi explanation, what to do next. Used for 404 and for 429 (too many
 * registration attempts).
 */
export function ErrorPage({
  code,
  title,
  children,
  actions,
  aside,
}: {
  code: number;
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  /** Extra box under the text, e.g. a countdown or tips. */
  aside?: ReactNode;
}) {
  const digits = toDeva(code).split('');
  return (
    <section className='error-page' aria-labelledby='error-title'>
      <div className='error-page__code' aria-hidden='true'>
        {digits.map((d, i) => <span key={i} style={{ animationDelay: `${i * 90}ms` }}>{d}</span>)}
      </div>
      <p className='error-page__status'>त्रुटी {toDeva(code)}</p>
      <h1 id='error-title' className='error-page__title'>{title}</h1>
      <div className='error-page__body'>{children}</div>
      {aside}
      <div className='error-page__actions'>
        {actions ?? <Link to='/' className='btn btn-primary btn-md'>मुखपृष्ठावर जा</Link>}
      </div>
    </section>
  );
}

export function NotFoundPage() {
  return (
    <div className='container content'>
      <ErrorPage
        code={404}
        title='हे पान सापडले नाही'
        actions={
          <>
            <Link to='/' className='btn btn-primary btn-md'>मुखपृष्ठावर जा</Link>
            <Link to='/register' className='btn btn-secondary btn-md'>नोंदणी करा</Link>
          </>
        }
      >
        <p>आपण उघडलेला दुवा चुकीचा आहे किंवा हे पान आता उपलब्ध नाही. वरील मेनूमधून हवे ते पान निवडा.</p>
      </ErrorPage>
    </div>
  );
}
